import { useCallback } from 'react';
import type { Store } from '@/types/store';
import { useUpdateFunnelDetails } from '../queries/useFunnelMutations';

/**
 * When the user publishes the first page of a still-unnamed funnel, auto-rename
 * the funnel to "Funnel - {productTitle}". No-ops if the funnel already has a
 * non-default name.
 */
export function useFunnelAutoRename(storeId: number | undefined, funnel: Store | null | undefined) {
    const updateFunnelDetails = useUpdateFunnelDetails();

    return useCallback(
        (order: number, productTitle: string) => {
            if (!storeId || !funnel) return;
            if (order !== 1) return;

            const existingName = funnel.data?.name?.trim() ?? '';
            const isDefaultName = existingName === '' || existingName === 'Funnel - Draft';
            if (!isDefaultName) return;

            const newName = `Funnel - ${productTitle}`.trim();
            if (!newName || newName === existingName) return;

            updateFunnelDetails.mutate({
                store_id: storeId,
                name: newName,
                slug: funnel.slug,
                type: 'funnel',
            });
        },
        [storeId, funnel, updateFunnelDetails]
    );
}
